<template>
  <div>
    <editor
      v-if="disabled"
      key="editor-disabled"
      v-model="local_value"
      lang="python"
      theme="idle_fingers"
      width="100%"
      style="fontsize: 18px;"
      @init="initialize_editor($event, true)"
    />
    <editor
      v-else
      key="editor-editing"
      v-model="local_value"
      lang="python"
      theme="chrome"
      width="100%"
      style="fontsize: 18px;"
      @init="initialize_editor($event)"
    />
  </div>
</template>

<script>
import _ from 'lodash'

import editor from 'vue2-ace-editor'
import * as ace from 'brace'
import 'brace/ext/language_tools'
import 'brace/mode/python'
import 'brace/mode/less'
import 'brace/theme/chrome'
import 'brace/snippets/python'
import 'brace/theme/idle_fingers'
import Fuse from 'fuse.js'

// *****************************************************************************

export default {
  name: 'CodeEditor',
  components: {
    editor,
  },
  props: ['value', 'columns', 'disabled'],
  data() {
    return {
      local_value: '',
      fuzzy_searcher: () => [],
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.local_value = nv
        }
      },
    },
    local_value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.$emit('input', nv)
        }
      },
    },
    columns(nv, ov) {
      let searcher = new Fuse(nv, {
        includeScore: true,
      })
      this.fuzzy_searcher = v => searcher.search(v)
    },
  },

  methods: {
    initialize_editor(editor, read_only = false) {
      editor.setReadOnly(read_only)
      editor.setOption('minLines', 10)
      editor.setOption('maxLines', 25)

      editor.setOptions({
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
      })

      let column_completer = {
        getCompletions: (editor, session, pos, prefix, callback) => {
          let res = []
          if (prefix.length !== 0) {
            let temp = this.fuzzy_searcher(prefix)
            res = temp.map(function (ea) {
              return {
                name: ea.item,
                value: ea.item,
                score: ea.score,
                meta: 'column',
              }
            })
          }
          callback(null, res)
        },
      }
      // https://github.com/thlorenz/brace/wiki/Advanced:-Accessing-somewhat-hidden-ACE-features
      let lang_tools = ace.acequire('ace/ext/language_tools')
      lang_tools.addCompleter(column_completer)
    },
  },
}
</script>
